// Form is based on Formik
// Data validation is based on Yup
// Please, be familiar with article first:
// https://hackernoon.com/react-form-validation-with-formik-and-yup-8b76bda62e10
import React, {useEffect} from "react";
import {useFormik} from "formik";
import * as Yup from "yup";
import {AEFile, AEInput} from "../../../../../_metronic/_partials/controls";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import {localField} from "../../../../../_emywork/helpers/UIHelper";


export function EditForm({ entity, btnRef, saveEntity, validationErrors = []}) {
  const dispatch = useDispatch();
  const {authUser} = useSelector( ({auth}) => ({ authUser:auth.user }), shallowEqual );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: entity,
    initialErrors: validationErrors,
    validationSchema: Yup.object().shape({
      name: Yup.string().required(),
      phone: Yup.string(),
      email: Yup.string().email(),
      note: Yup.string(),
    }),
    onSubmit: (values)=>{
      const {id, name, phone, email, note, file_name} = values;
      saveEntity(
        {
          id, name, phone, email,  note,
          user_id: authUser.id
        },
        file_name
      )
    }
  });

  const { handleSubmit, getFieldProps, setFieldValue, values, setValues } = formik

  useEffect(()=>{
    //
  }, [dispatch])

  const _props = (name, label, type)=>{
    let p = {
      name, label,
      field: getFieldProps(name),
      form: formik,
    };

    switch (type){
      case "autocomplete": {
        p.useId = true;
        p.getOptionLabel= o=>o[localField()]
      } break;

      case "textarea": {
        p.type = type
      } break;
    }

    return p
  }

  return (
    <>
      <div className="form form-label-right">
        <div className="form-group row py-1">
          <div className={"col-lg-4"}>
            <AEInput {..._props('name','NAME')} />
          </div>
          <div className={"col-lg-4"}>
            <AEInput {..._props('phone','PHONE')} />
          </div>
          <div className={"col-lg-4"}>
            <AEInput {..._props('email','EMAIL')} />
          </div>
        </div>
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEInput
              {..._props('note','NOTE','textarea')}
              rows={3}
            />
          </div>
        </div>
        <div className="form-group row py-1">
          <div className={"col-lg-12"}>
            <AEFile
              {..._props('file_name','ATTACHMENT')}
            />
          </div>
        </div>

        <button
          style={{ display: "none" }}
          ref={btnRef}
          onClick={()=>{handleSubmit()}}
        />
      </div>
    </>
  );
}

